// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoSection_root__1YKIZ"};